import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import DotSvg from './components/DotSvg'
import { PinKeyboard } from '../../../shared/PinKeyboard/PinKeyboard'
import { theme } from '../../../utils/constant'
import { useApp } from '../../../context/usePortal'
import logo from '../../../assets/logos/aye-logo.png'

const RegisterPinScreen: React.FC = () => {
  const { setUserPin } = useApp()
  const navigate = useNavigate()
  const [pinCode, setPinCode] = useState<number[]>([])
  const [savedPin, setSavedPin] = useState<number[]>([])
  const [error, setError] = useState<string>('')
  const [message, setMessage] = useState<string>('PIN')
  const location = useLocation()

  const handlePinClick = (pin: number) => {
    if (pin === -1) {
      const pincodeList = pinCode
      pincodeList.pop()
      return setPinCode((value) => (value.length === 0 ? [] : [...pincodeList]))
    }

    if (pinCode.length < 6)
      setPinCode((value) => (value.length < 6 ? [...value, pin] : value))
  }

  useEffect(() => {
    const registrationStarted =
      sessionStorage.getItem('registration_started') === 'true'
    const step = sessionStorage.getItem('step')

    if (step !== '1' || !registrationStarted) {
      navigate('/login')
    }

    const queryParams = new URLSearchParams(window.location.search)
    const token = queryParams.get('token')

    if (!token) {
      navigate('/login')
    }

    if (pinCode.length === 6 && savedPin.length === 0) {
      setSavedPin(pinCode)
      setPinCode([])
      setMessage('Confirm your PIN')
    }

    if (pinCode.length === 6 && savedPin.length === 6) {
      if (JSON.stringify(savedPin) === JSON.stringify(pinCode)) {
        setUserPin(savedPin)
        sessionStorage.setItem('step', '2')
        sessionStorage.setItem('pinComplete', 'true')
        sessionStorage.setItem('pin', savedPin.join(''))
        return navigate('/register/payment', {
          state: { token },
          replace: true,
        })
      } else {
        setMessage('PIN')
        setError('Incorrect Pin. Please Retry')
        setPinCode([])

        setTimeout(() => {
          setError('')
        }, 1500)
      }
    }
  }, [pinCode, savedPin, location])

  return (
    <div className="flex flex-col items-center justify-center bg-white">
      <img src={logo} alt="Aye Logo" width={'7%'} className="mt-4" />
      <div className="flex h-full w-full flex-col items-center justify-center">
        <div className="flex h-full w-full flex-col items-center justify-center">
          <p
            className="mt-4 text-center font-bold"
            style={{ fontSize: theme.textSize.values.title2 }}>
            {message}
          </p>
          <p
            className="mt-[-0.8rem] text-center"
            style={{ fontSize: theme.textSize.values.subTitle }}>
            Please setup your 6 digit PIN
          </p>
        </div>
        <div className="flex h-full w-full items-center justify-center">
          <img
            className="lockImage mt-10"
            src={
              message === 'PIN'
                ? require('../../../assets/red_lock.png')
                : require('../../../assets/lock_confirm.png')
            }
            alt="Lock"
            width={'7%'}
          />
        </div>
      </div>
      <div className="flex h-full w-[40%] flex-col items-center justify-center bg-white shadow-md">
        <div className="mt-8 flex min-h-full w-full items-center justify-center">
          <div className="surface">
            <div className="mb-4 flex h-full w-full items-center justify-center gap-4">
              {Array.from({ length: 6 }).map((_, i) => {
                return (
                  <div className="dotWrapper" key={i}>
                    <DotSvg
                      background={
                        i < pinCode.length ? theme.colors.primary : 'white'
                      }
                    />
                  </div>
                )
              })}
            </div>
            {error ? (
              <p className="mt-[-0.8rem] text-center text-red-600">{error}</p>
            ) : (
              ''
            )}
            <div className="flex h-full w-full items-center justify-center">
              <div className="flex h-full w-[70%] items-center justify-center">
                <PinKeyboard onTap={handlePinClick} />
              </div>
            </div>
          </div>
        </div>
        <button
          onClick={() =>
            window.open('https://paynet.my/about-paynet.html', '_blank')
          }>
          Authorised by <span className="font-bold text-blue-600">Pay</span>
          <span className="font-bold text-green-600">Net</span>
        </button>
      </div>
    </div>
  )
}

export default RegisterPinScreen
